<template>
    <div class="metric-pill display-flex align-items-center">
        <div
            class="metric-pill__container display-flex bg-stone-50"
            :class="{ disabled: props.disabled }"
        >
            <div
                v-for="pill in props.steps"
                class="metric-pill__item display-flex align-items-center justify-center"
                :class="[
                    {
                        'metric-pill__item--active':
                            pill.label.slice(0, 3) === props.currentValue.slice(0, 3),
                    },
                    `metric-pill__item--${pill.label.toLowerCase()}`,
                ]"
                :style="rangeStyle"
            >
                <p class="font-base p-sm">{{ pill.label }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'

const props = defineProps({
    steps: {
        type: Object,
        default: () => {},
    },
    currentValue: {
        type: String,
        default: '',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const rangeStyle = computed(() => {
    const stepWidth = 100 / props.steps.length

    return {
        width: `${stepWidth}%`,
    }
})
</script>

<style scoped lang="scss">
@forward '@/styles/new_styles.scss';

.metric-pill {
    p {
        text-wrap: nowrap;
    }

    &__container {
        width: 100%;
        height: 34px;
        padding: var(--spacing-xxs);
        border-radius: var(--border-radius-xl);
        position: relative;
    }

    &__item {
        text-align: center;
        border-radius: var(--border-radius-xl);
        color: var(--text-secondary);
        min-width: 60px;
        height: 26px;
        padding-top: 4px !important;

        &--active {
            background: var(--color-stone-0);
            box-shadow: var(--shadow-sm);
            p {
                font-weight: 600 !important;
            }

            &.metric-pill__item--low {
                color: var(--color-error);
            }

            &.metric-pill__item--med {
                color: var(--color-warning);
            }

            &.metric-pill__item--high,
            &.metric-pill__item--not {
                color: var(--color-success);
            }
        }
    }
}
</style>
